import React from 'react'
import { Spinner } from './style'
const SpinnerWheel = ({ variant = 'default', ...props }) => {
  return <Spinner variant={variant} {...props} />
}
export default SpinnerWheel
